/**
 * Referral code entry snippet logic (Instant embed).
 * KISS: no error messaging, just disable until non-empty, then redirect.
 */

(function () {
  'use strict';

  function normalizeCode(raw) {
    return String(raw || '').trim().toUpperCase();
  }

  function getAutofillFromUrl() {
    try {
      const params = new URLSearchParams(window.location.search);
      const snowball = params.get('snowball');
      if (snowball && String(snowball).trim()) return { key: 'snowball', value: String(snowball).trim() };
      const discount = params.get('discount');
      if (discount && String(discount).trim()) return { key: 'discount', value: String(discount).trim() };
    } catch (e) {}
    return null;
  }

  function init(root) {
    const input = root.querySelector('[data-referral-code-input]');
    const button = root.querySelector('[data-referral-code-submit]');
    const wizard2Url = root.getAttribute('data-wizard-2-url') || '/wizard-2';

    if (!input || !button) return;

    const syncDisabled = () => {
      const code = normalizeCode(input.value);
      button.disabled = !code;
    };

    const submit = () => {
      const code = normalizeCode(input.value);
      if (!code) return;

      let url;
      try {
        url = new URL(wizard2Url, window.location.origin);
      } catch (e) {
        url = new URL('/wizard-2', window.location.origin);
      }
      // Preserve existing query params (utm_*, gclid, etc.) for future needs.
      try {
        const current = new URL(window.location.href);
        current.searchParams.forEach((value, key) => {
          if (!url.searchParams.has(key)) {
            url.searchParams.set(key, value);
          }
        });
      } catch (e) {}
      // Keep the same semantics as the landing URL:
      // - snowball param indicates Social Snowball referral
      // - discount param indicates Shopify /discount creator link
      const autofill = getAutofillFromUrl();
      const paramKey = autofill?.key === 'discount' ? 'discount' : 'snowball';
      url.searchParams.set(paramKey, code);
      window.location.href = url.toString();
    };

    input.addEventListener('input', syncDisabled, { passive: true });
    input.addEventListener('keydown', e => {
      if (e.key === 'Enter') {
        e.preventDefault();
        if (!button.disabled) submit();
      }
    });
    button.addEventListener('click', () => {
      if (!button.disabled) submit();
    });

    // Auto-fill from URL (snowball wins over discount) and enable immediately.
    const autofill = getAutofillFromUrl();
    if (autofill && autofill.value) {
      input.value = String(autofill.value);
      // Trigger floating label + enable button immediately.
      try {
        input.dispatchEvent(new Event('input', { bubbles: true }));
      } catch (e) {}
    }

    syncDisabled();
  }

  function boot() {
    document.querySelectorAll('[data-referral-code-entry]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();

